import React from 'react'
import TextSection from '../../sections/TextSection'
import { TextSliceProps } from './types'

const TextSlice: React.FC<TextSliceProps> = ({ slice }) => {
  const { t_title, t_description, t_is_full_width } = slice.primary || {}

  return (
    <TextSection
      headingPadding={['45px', '', '85px']}
      inner="inners.primary"
      paddingTop={['40px', '', '84px']}
      paddingBottom={['40px', '', '80px']}
      data={{
        title: t_title?.text,
        content: t_description?.html
      }}
      isFullWidth={t_is_full_width}
    />
  )
}

export default TextSlice
